export const regionData = [
	{
		id: 1,
		region: '서울',
		areaCode: 'SEOUL',
	},
	{
		id: 2,
		region: '경기',
		areaCode: 'GYEONGGI',
	},
	{
		id: 3,
		region: '인천',
		areaCode: 'INCHEON',
	},
	{
		id: 4,
		region: '강원',
		areaCode: 'GANGWON',
	},
	{
		id: 5,
		region: '제주',
		areaCode: 'JEJU',
	},
	{
		id: 6,
		region: '대전',
		areaCode: 'DAEJEON',
	},
	{
		id: 7,
		region: '충북',
		areaCode: 'CHUNGBUK',
	},
	{
		id: 8,
		region: '충남/세종',
		areaCode: 'CHUNGNAM',
	},
	{
		id: 9,
		region: '부산',
		areaCode: 'BUSAN',
	},
	{
		id: 10,
		region: '울산',
		areaCode: 'ULSAN',
	},
	{
		id: 11,
		region: '경남',
		areaCode: 'GYEONGNAM',
	},
	{
		id: 12,
		region: '대구',
		areaCode: 'DAEGU',
	},
	{
		id: 13,
		region: '경북',
		areaCode: 'GYEONGBUK',
	},
	{
		id: 14,
		region: '광주',
		areaCode: 'GWANGJU',
	},
	{
		id: 15,
		region: '전남',
		areaCode: 'JEONNAM',
	},
	{
		id: 16,
		region: '전주/전북',
		areaCode: 'JEONBUK',
	},
];
